import {
  Palette,
  Ruler,
  Shirt,
  Grid3X3,
  Layers,
  Sparkles,
  Hash,
  Link2,
} from 'lucide-react';
import type { VariationType } from '@/lib/types';

export const VARIATION_TYPES: { value: VariationType; labelKey: string; icon: React.ReactNode }[] = [
  { value: 'color', labelKey: 'associations.variationTypes.color', icon: <Palette className="size-4" /> },
  { value: 'size', labelKey: 'associations.variationTypes.size', icon: <Ruler className="size-4" /> },
  { value: 'size_color', labelKey: 'associations.variationTypes.size_color', icon: <Grid3X3 className="size-4" /> },
  { value: 'style', labelKey: 'associations.variationTypes.style', icon: <Shirt className="size-4" /> },
  { value: 'pattern', labelKey: 'associations.variationTypes.pattern', icon: <Layers className="size-4" /> },
  { value: 'material', labelKey: 'associations.variationTypes.material', icon: <Sparkles className="size-4" /> },
  { value: 'flavor', labelKey: 'associations.variationTypes.flavor', icon: <Sparkles className="size-4" /> },
  { value: 'quantity', labelKey: 'associations.variationTypes.quantity', icon: <Hash className="size-4" /> },
  { value: 'related', labelKey: 'associations.variationTypes.related', icon: <Link2 className="size-4" /> },
];

export const MAX_PRODUCTS = 10;
